import autobind from 'core-decorators/lib/autobind';

import { notForPreview } from 'widget/utils/not-for-preview';

import { openFullScreenPurchaseOverlay, openFullScreenSubscribeOverlay } from 'shared/utils/open-overlay';


export default class PlayerActionCallbacks extends React.Component {

  static propTypes = {
    children: React.PropTypes.element.isRequired,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
  };

  @autobind
  @notForPreview
  showPurchaseInfoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenPurchaseOverlay(channelId, videoId);
  }

  @autobind
  @notForPreview
  showChannelSubscriptionInfoAtOverlay() {
    openFullScreenSubscribeOverlay(this.props.channelId);
  }

  render() {
    return React.cloneElement(this.props.children, {
      // TODO: rename to onPurchaseRequest and onSubscriptionRequest
      onPurchaseClick: this.showPurchaseInfoAtOverlay,
      onSubscribeClick: this.showChannelSubscriptionInfoAtOverlay,
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/player-action-callbacks.js